/**
 * App Store configuration — single source of truth for the iOS app links.
 *
 * AT LAUNCH: paste the numeric App Store ID below (App Store Connect → your app →
 * App Information → "Apple ID", a number like 6612345678). That one value turns on
 * BOTH the native Smart App Banner (Safari) and the custom "Get the app" banner
 * (every other mobile browser). Until it's set, neither banner shows.
 */
export const APP_STORE_APP_ID = '6778002466';

export const APP_NAME = 'Prompt-Brush';

export const APP_STORE_URL = APP_STORE_APP_ID
  ? `https://apps.apple.com/app/prompt-brush/id${APP_STORE_APP_ID}`
  : '';
